var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "plan-streams-divider",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2,
    height: 100,
    viewBox: "0 0 2 99",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V98.5",
    stroke: "#FEBC2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.186a53cbf35df85fd5160960e60d809d.svg";
export { ForwardRef as ReactComponent };